// extracted by mini-css-extract-plugin
module.exports = {"ctaContainer":"marca-propria-cta_ctaContainer__3TOHP"};